<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 md12 sm12>
        <v-container>
          <v-card style="padding: 10px 15px; border-radius: 3px" elevation="1">
            <v-flex xs12 sm12 md12 style="padding: 5px 10px">
              <full-datepicker @updateDate="updateDate"></full-datepicker>
            </v-flex>

            <v-layout row style="padding: 2px 15px">
              <v-flex v-if="$store.state.userDetails.role != 'User'" xs6 sm6 md6>
                User Filter
                <v-btn @click="showFilter = !showFilter" icon text>
                  <v-badge v-if="filtersApplied" color="red" fill small overlap>
                    <template v-slot:badge>
                      <span small></span>
                    </template>
                    <v-icon v-if="showFilter" medium>filter_list</v-icon>
                    <v-icon v-else medium>filter_list</v-icon>
                  </v-badge>

                  <v-icon v-else-if="!filtersApplied && showFilter" medium>filter_list</v-icon>
                  <v-icon v-else-if="!filtersApplied && !showFilter" medium>filter_list</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6 sm6 md6 style="margin-top: -15px; padding-left: 25px">
                <v-layout row>
                  <v-switch v-model="dayWise" v-bind:label="'Day Wise'" color="primary"></v-switch>

                  <v-tooltip v-model="showDayWiseInfo" right>
                    <template v-slot:activator="{ on }">
                      <div style="padding-top: 14px;">
                        <v-btn @click="showDayWiseInfo = !showDayWiseInfo" icon>
                          <v-icon color="grey lighten-1">info</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>Day Wise Reports</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-flex v-if="showFilter" xs12 sm12 md12>
              <user-filter ref="userFilter"></user-filter>
            </v-flex>

            <v-layout row>
              <v-flex v-if="!dayWise" xs12 sm6 md6 style="padding: 5px 10px">
                <v-card
                  elevation="0"
                  style="padding: 5px 5px 5px 12px; border-radius: 3px; background-color: transparent; border: 1px solid #e8e8e8"
                >
                  <v-checkbox
                    v-model="showHolidays"
                    color="primary"
                    label="Include Holidays"
                  ></v-checkbox>
                </v-card>
              </v-flex>

              <v-flex v-if="!dayWise" xs12 sm6 md6 style="padding: 5px 10px">
                <v-card
                  elevation="0"
                  style="padding: 5px 5px 5px 12px; border-radius: 3px; background-color: transparent; border: 1px solid #e8e8e8"
                >
                  <v-checkbox
                    v-model="showWeeklyoffs"
                    color="primary"
                    label="Include Weeklyoffs"
                  ></v-checkbox>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md6 style="padding: 5px 10px">
                <v-card
                  elevation="0"
                  style="padding: 5px 5px 5px 12px; border-radius: 3px; background-color: transparent; border: 1px solid #e8e8e8"
                >
                  <v-checkbox
                    v-model="showUnapprovedPunches"
                    color="primary"
                    label="Show Unapproved Punches"
                  ></v-checkbox>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md6 style="padding: 5px 10px">
                <v-card
                  elevation="0"
                  style="padding: 5px 5px 5px 12px; border-radius: 3px; background-color: transparent; border: 1px solid #e8e8e8"
                >
                  <v-checkbox
                    v-model="considerPunchesOutsideShift"
                    color="primary"
                    label="Consider Punches Outside Shift"
                  ></v-checkbox>
                </v-card>
              </v-flex>
            </v-layout>

            <v-flex xs12 sm12 md12 style="text-align: center; padding: 10px 15px 5px 15px">
              <v-btn
                @click="calcReport()"
                :loading="calcResult ? true : false"
                rounded
                class="primary"
                text-color="white"
              >
                Calculate
              </v-btn>
            </v-flex>

            <v-card-actions v-if="reportExport.length > 0" style="margin-top: 10px; ">
              <v-layout row>
                <v-flex xs10 sm10 md10 style="padding: 5px 15px">
                  <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    label="Search..."
                    single-line
                    hide-details
                    solo
                    clearable
                  ></v-text-field>
                </v-flex>

                <v-flex xs2 sm2 md2 style="padding: 5px 15px; text-align: center">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" dark icon>
                        <v-icon class="black--text">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-card class="elevation-0">
                      <v-card-text class="pa-0">
                        <v-list class="pa-0">
                          <v-list-item @click="exportInCSV" style="cursor: pointer">
                            <v-list-item-avatar>
                              <v-icon medium dark color="primary">get_app</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              Master Report
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm12 md12 style="padding: 5px 15px">
                  <v-data-table
                    :headers="headers"
                    :items="reportExport"
                    :search="search"
                    :items-per-page="5"
                    style="margin-top: 10px"
                    class="elevation-2"
                  >
                    <template v-slot:item.PunchImage="{ item }">
                      <img :src="item.PunchImage" width="50" />
                    </template>
                    <template v-slot:item.FirstInImage="{ item }">
                      <img :src="item.FirstInImage" width="50" />
                    </template>
                    <template v-slot:item.LastOutImage="{ item }">
                      <img :src="item.LastOutImage" width="50" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import blob from "blob";
import Papa from "papaparse";
import { mapState } from "vuex";
//import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";
import { isMobile } from "mobile-device-detect";
//import { Datetime } from "vue-datetime";
import { EventBus } from "@/utilities/event-bus.js";
//import "vue-datetime/dist/vue-datetime.css";
import VNodata from "@/components/Unavailable/nodata.vue";

export default {
  //components: { DatePicker, datetime: Datetime, VNodata },
  components: { VNodata },
  data() {
    return {
      calculateHours: false,
      showcalculateHoursInfo: false,
      showHolidays: false,
      showWeeklyoffs: false,
      dayWise: false,
      showUnapprovedPunches: false,
      considerPunchesOutsideShift: false,
      showDayWiseInfo: false,
      showFilter: false,
      filtersApplied: false,
      fields: [],

      fieldsDataDayWise: [
        { fieldName: "First Name" },
        { fieldName: "Last Name" },
        { fieldName: "Email" },
        { fieldName: "Employee Code" },
        { fieldName: "Group" },
        { fieldName: "Timezone" },
        { fieldName: "Role" },
        { fieldName: "Supervisor" },
        { fieldName: "Address" }
      ],
      calcResult: false,
      punchDetails: [],
      locationList: [],
      allUsers: [],
      shifts: [],
      allWeekOffs: [],
      allHolidays: [],
      selectedTimeStart: "",
      selectedTimeEnd: "",
      selectedTags: {},
      reportExport: [],
      groupLists: [],
      headers: [],
      search: "",
      allTags: [],
      unsub: () => {}
    };
  },
  computed: {},
  created() {
    const self = this;
    self.getShiftData(); // shifts in this company
    self.getLocations(); // locations
    self.getWeekOffs(); // weekly offsets
    self.getHolidays(); // holidays
    self.getGroups(); //groups

    self.unsub = self.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setSelectedTags" ||
        mutation.type === "setMode" ||
        mutation.type === "setGroup"
      ) {
        const opts = {
          tags: _.map(
            _.filter(state.selectedTags, t => t.type == "tag"),
            "id"
          ),
          locations: _.map(
            _.filter(state.selectedTags, t => t.type == "location"),
            "id"
          ),
          mode: state.mode,
          group: state.group
        };
        self.selectedTags = opts;
      }
    });

    // get tags
    this.$http
      .get(
        `${this.$store.state.endpoint}tags?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
      )
      .then(
        response => {
          this.allTags = response.body;
        },
        error => {
          console.log(error);
        }
      );
  },
  methods: {
    updateDate(startDate, endDate) {
      this.selectedTimeStart = startDate;
      this.selectedTimeEnd = endDate;
    },

    getShiftData() {
      this.shifts = [];
      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.shifts = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    getLocations() {
      const self = this;
      self.locationList = [];

      self.$http
        .get(
          `${self.$store.state.endpoint}Locations?filter[where][companyId]=${self.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            self.locationList = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },
    // not needed but just in case
    getWeekOffs() {
      const self = this;
      self.allWeekOffs = [];
      self.$http
        .get(
          `${self.$store.state.endpoint}weeklyOffSets?filter[where][companyId]=${self.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            self.allWeekOffs = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    // not needed but just in case
    getHolidays() {
      const self = this;
      self.allHolidays = [];
      self.$http
        .get(
          `${self.$store.state.endpoint}holidaySets?filter[where][companyId]=${self.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            self.allHolidays = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    getGroups() {
      const self = this;
      self.groupLists = [];
      self.$http
        .get(
          `${self.$store.state.endpoint}groups?filter[where][companyId]=${self.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            self.groupLists = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    // get each group name by passing id
    getGroupName(id) {
      for (var i in this.groupLists) {
        if (this.groupLists[i].id == id) {
          return this.groupLists[i].name;
        }
      }
    },

    // get each tag name by passing id
    getTagName(id) {
      for (var i in this.allTags) {
        if (this.allTags[i].id == id) {
          return this.allTags[i].name;
        }
      }
    },

    // calculate
    calcReport() {
      const self = this;
      self.calcResult = true;
      self.reportExport = [];

      this.showMasterReport().then(function(allUsers) {
        if (self.showWeeklyoffs) {
          self.fields.push("WeeklyOffs", "WeeklyOff Types");
        }

        if (self.showHolidays) {
          self.fields.push("Holidays", "Holiday Types");
        }

        function getUserName(value) {
          const userData = allUsers;

          for (const o in userData) {
            if (userData[o].id == value) {
              return `${userData[o].firstName} ${userData[o].lastName}`;
            }
          }
        }

        for (var x in allUsers) {
          try {
            if (Object.keys(allUsers[x]["attendances"]).length > 0) {
              for (var y in allUsers[x]["attendances"]) {
                // payload to be saved according to custom fields

                var payload = {
                  "First Name": allUsers[x]["firstName"],
                  "Last Name": allUsers[x]["lastName"],
                  Role: allUsers[x]["role"],
                  Supervisor: getUserName(allUsers[x].supervisor),
                  "Employee Code": "code" in allUsers[x] ? allUsers[x]["code"] : "",
                  Email: allUsers[x]["email"]
                };

                payload["Group"] = _.join(
                  _.map(allUsers[x]["groupId"], d => {
                    return self.getGroupName(d);
                  }),
                  ", "
                );

                payload["Tag"] = _.join(
                  _.map(allUsers[x]["tags"], d => {
                    return self.getTagName(d);
                  }),
                  ", "
                );

                if (self.dayWise) {
                  payload["Date"] = y;
                  payload["Present"] = allUsers[x]["attendances"][y]["present"];

                  // actual hours and total hours
                  payload["Actual Hours"] = moment
                    .utc(Number(allUsers[x]["attendances"][y]["actualHours"]) * 3600 * 1000)
                    .format("HH:mm");
                  payload["Total Hours"] = moment
                    .utc(Number(allUsers[x]["attendances"][y]["totalHours"]) * 3600 * 1000)
                    .format("HH:mm");

                  // first punch
                  payload["First In GPS"] = "";
                  payload["First In Address"] = "";
                  payload["First In Location"] = "";
                  payload["First In Shift"] = "";
                  payload["First In Early/Late"] = "";
                  payload["First In Early/Late minutes"] = "";
                  payload["First In Time"] = "";
                  payload["First In Date"] = "";
                  payload["First In Timezone"] = "";
                  payload["FirstInImage"] = "";

                  // last punch
                  payload["Last Out Location"] = "";
                  payload["Last Out GPS"] = "";
                  payload["Last Out Address"] = "";
                  payload["Last Out Time"] = "";
                  payload["Last Out Date"] = "";
                  payload["Last Out Shift"] = "";
                  payload["Last Out Early/Late"] = "";
                  payload["Last Out Early/Late minutes"] = "";
                  payload["Last Out Timezone"] = "";
                  payload["LastOutImage"] = "";

                  // include weekly offs
                  payload["WeeklyOff Today"] = "";
                  payload["WeeklyOff Name"] = "";
                  payload["WeeklyOff Type"] = "";

                  // include holidays
                  payload["Holiday Today"] = "";
                  payload["Holiday Name"] = "";
                  payload["Holiday Type"] = "";

                  // first punch
                  if (allUsers[x]["attendances"][y]["firstPunch"]) {
                    payload["First In Timezone"] =
                      allUsers[x]["attendances"][y]["firstPunch"]["timezone"]["name"];

                    payload["First In Time"] = moment(
                      allUsers[x]["attendances"][y]["firstPunch"]["time"]
                    ).format("HH:mm:ss");

                    payload["First In Date"] = moment(
                      allUsers[x]["attendances"][y]["firstPunch"]["time"]
                    ).format("DD/MM/YYYY");

                    payload["First In GPS"] =
                      "gps" in allUsers[x]["attendances"][y]["firstPunch"]
                        ? `${allUsers[x]["attendances"][y]["firstPunch"]["gps"]["lat"]}, ${allUsers[x]["attendances"][y]["firstPunch"]["gps"]["lng"]}`
                        : "";

                    payload["First In Address"] = allUsers[x]["attendances"][y]["lastPunch"][
                      "address"
                    ]
                      ? allUsers[x]["attendances"][y]["lastPunch"]["address"]["display_name"]
                      : "";

                    payload["First In Location"] =
                      allUsers[x]["attendances"][y]["firstPunch"].originalLocation.name;

                    payload["First In Shift"] =
                      "originalShift" in allUsers[x]["attendances"][y]["firstPunch"]
                        ? allUsers[x]["attendances"][y]["firstPunch"].originalShift[0].name
                        : "";

                    payload["First In Early/Late"] =
                      "originalShift" in allUsers[x]["attendances"][y]["firstPunch"]
                        ? allUsers[x]["attendances"][y]["firstPunch"].originalShift[0].offset.late
                          ? "Late"
                          : "Early"
                        : "";

                    payload["First In Early/Late minutes"] =
                      "originalShift" in allUsers[x]["attendances"][y]["firstPunch"]
                        ? allUsers[x]["attendances"][y]["firstPunch"].originalShift[0].offset.by
                        : "";

                    payload["FirstInImage"] =
                      "image" in allUsers[x]["attendances"][y]["firstPunch"]
                        ? self.$store.state.imagePath +
                          allUsers[x]["attendances"][y]["firstPunch"]["image"]
                        : "";
                  }

                  // last punch
                  if (allUsers[x]["attendances"][y]["lastPunch"]) {
                    payload["Last Out Timezone"] =
                      allUsers[x]["attendances"][y]["lastPunch"]["timezone"]["name"];

                    payload["Last Out Location"] =
                      allUsers[x]["attendances"][y]["lastPunch"].originalLocation.name;

                    payload["Last Out Shift"] =
                      "originalShift" in allUsers[x]["attendances"][y]["lastPunch"]
                        ? allUsers[x]["attendances"][y]["lastPunch"].originalShift[0].name
                        : "";

                    payload["Last Out Early/Late"] =
                      "originalShift" in allUsers[x]["attendances"][y]["lastPunch"]
                        ? allUsers[x]["attendances"][y]["lastPunch"].originalShift[0].offset.late
                          ? "Late"
                          : "Early"
                        : "";

                    payload["Last Out Early/Late minutes"] =
                      "originalShift" in allUsers[x]["attendances"][y]["lastPunch"]
                        ? allUsers[x]["attendances"][y]["lastPunch"].originalShift[0].offset.by
                        : "";

                    payload["Last Out GPS"] =
                      "gps" in allUsers[x]["attendances"][y]["lastPunch"]
                        ? `${allUsers[x]["attendances"][y]["lastPunch"]["gps"]["lat"]}, ${allUsers[x]["attendances"][y]["lastPunch"]["gps"]["lng"]}`
                        : "";

                    payload["Last Out Address"] = allUsers[x]["attendances"][y]["lastPunch"][
                      "address"
                    ]
                      ? allUsers[x]["attendances"][y]["lastPunch"]["address"]["display_name"]
                      : "";

                    payload["Last Out Time"] = moment(
                      allUsers[x]["attendances"][y]["lastPunch"]["time"]
                    ).format("HH:mm:ss");

                    payload["Last Out Date"] = moment(
                      allUsers[x]["attendances"][y]["lastPunch"]["time"]
                    ).format("DD/MM/YYYY");

                    payload["LastOutImage"] =
                      "image" in allUsers[x]["attendances"][y]["lastPunch"]
                        ? self.$store.state.imagePath +
                          allUsers[x]["attendances"][y]["lastPunch"]["image"]
                        : "";
                  }

                  payload["WeeklyOff Today"] =
                    allUsers[x]["attendances"][y]["firstPunch"].weeklyOff != undefined
                      ? allUsers[x]["attendances"][y]["firstPunch"].weeklyOff.length > 0
                        ? true
                        : false
                      : false;

                  payload["WeeklyOff Name"] = _.join(
                    _.map(allUsers[x]["attendances"][y]["firstPunch"].weeklyOff, d => {
                      return d.name;
                    }),
                    ", "
                  );

                  payload["WeeklyOff Type"] = _.join(
                    _.map(allUsers[x]["attendances"][y]["firstPunch"].weeklyOff, d => {
                      return d.halfDay
                        ? d.halfDayHalf == 1
                          ? "First Half"
                          : "Second Half"
                        : "Full Day";
                    }),
                    ", "
                  );

                  payload["Holiday Today"] =
                    allUsers[x]["attendances"][y]["firstPunch"].holiday != undefined
                      ? allUsers[x]["attendances"][y]["firstPunch"].holiday.length > 0
                        ? true
                        : false
                      : false;

                  payload["Holiday Name"] = _.join(
                    _.map(allUsers[x]["attendances"][y]["firstPunch"].holiday, d => {
                      return d.name;
                    }),
                    ", "
                  );

                  payload["Holiday Type"] = _.join(
                    _.map(allUsers[x]["attendances"][y]["firstPunch"].holiday, d => {
                      return d.halfDay
                        ? d.halfDayHalf == 1
                          ? "First Half"
                          : "Second Half"
                        : "Full Day";
                    }),
                    ", "
                  );

                  self.reportExport.push(payload); //push payload
                } else {
                  //Non daywise
                  for (var z in allUsers[x]["attendances"][y]["punches"]) {
                    var res = new Object();
                    if (self.considerPunchesOutsideShift) {
                      res = self.createPayload(
                        allUsers[x]["attendances"][y]["punches"][z],
                        payload
                      );
                      // push payload
                      self.reportExport.push(res);
                    } else {
                      if ("originalShift" in allUsers[x]["attendances"][y]["punches"][z]) {
                        res = self.createPayload(
                          allUsers[x]["attendances"][y]["punches"][z],
                          payload
                        );
                        // push payload
                        self.reportExport.push(res);
                      } else {
                        continue;
                      }
                    }
                  } // END OF LOOP
                }
              }
            }
          } catch (e) {
            console.log(e);
          }
        }

        self.headers = [];

        // headers assignment
        if (self.reportExport.length > 0) {
          var allHeaders = [];
          _.each(self.reportExport, r => {
            allHeaders.push(Object.keys(r));
          });

          allHeaders = _.uniq(_.flatten(allHeaders));

          self.headers = _.map(allHeaders, d => {
            return {
              value: d,
              align: "left",
              text: d
            };
          });
        }
        self.calcResult = false;
        self.fields = [];
      });
    },

    // non day wise report payload generator
    createPayload(punch, payload) {
      //Formats rows for non day wise punches
      const self = this;
      var data = {
        "First Name": payload["First Name"],
        "Last Name": payload["Last Name"],
        Role: payload["Role"],
        Supervisor: payload["Supervisor"],
        "Employee Code": payload["Employee Code"],
        Email: payload["Email"],
        Group: payload["Group"],
        Tag: payload["Tag"]
      };
      try {
        data["Date"] = moment(punch.attendanceDay).format("DD/MM/YYYY");
        data["Punch Type"] = punch.punchType;
        data["Punch Time"] = moment(punch.time).format("HH:mm");
        data["Punch Date"] = moment(punch.time).format("DD/MM/YYYY");
        data["Punch Timezone"] = punch.timezone.name;
        data["Punch GPS"] = "gps" in punch ? `${punch["gps"]["lat"]}, ${punch["gps"]["lng"]}` : "";
        data["Punch Address"] = punch.address ? punch.address.display_name : "";
        data["Punch Location"] = punch.originalLocation.name;
        data["Punch Shift"] = "originalShift" in punch ? punch.originalShift[0].name : "";
        data["Early/Late"] =
          "originalShift" in punch ? (punch.originalShift[0].offset.late ? "Late" : "Early") : "";
        data["Early/Late minutes"] =
          "originalShift" in punch ? punch.originalShift[0].offset.by : "";
        // include weekoffs
        if (self.showWeeklyoffs) {
          data["WeeklyOff Today"] =
            punch.weeklyOff != undefined ? (punch.weeklyOff.length > 0 ? true : false) : false;

          data["WeeklyOff Name"] = _.join(
            _.map(punch.weeklyOff, d => {
              return d.name;
            }),
            ", "
          );
          data["WeeklyOff Type"] = _.join(
            _.map(punch.weeklyOff, d => {
              return d.halfDay ? (d.halfDayHalf == 1 ? "First Half" : "Second Half") : "Full Day";
            }),
            ", "
          );
        }

        // include holidays
        if (self.showHolidays) {
          data["Holiday Today"] =
            punch.holiday != undefined ? (punch.holiday.length > 0 ? true : false) : false;

          data["Holiday Name"] = _.join(
            _.map(punch.holiday, d => {
              return d.name;
            }),
            ", "
          );
          data["Holiday Type"] = _.join(
            _.map(punch.holiday, d => {
              return d.halfDay ? (d.halfDayHalf == 1 ? "First Half" : "Second Half") : "Full Day";
            }),
            ", "
          );
        }
        data["PunchImage"] = "image" in punch ? this.$store.state.imagePath + punch.image : "";

        return data;
      } catch (e) {
        console.log(e);
      }
    },

    exportInCSV() {
      var csv = Papa.unparse(this.reportExport);

      if (this.$mq != "mobile") {
        try {
          var csvData = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, "download.csv");
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "download.csv");
          tempLink.click();
        } catch (e) {
          console.log(e);
        }
      } else {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function(dir) {
          console.log("dir", dir);
          dir.getFile(
            "export-report-" + new Date().getTime() + ".csv",
            {
              create: true
            },
            function(file) {
              console.log("file", file);

              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {
                    fileWriter.seek(fileWriter.length);
                    var blob = new Blob([str], {
                      type: "text/csv;charset=utf-8;"
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({ type: "error", text: "Something went wrong" });
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },

    showMasterReport(tags) {
      return new Promise((resolve, reject) => {
        if (typeof tags !== "undefined" && tags.hasOwnProperty("locations"))
          this.selectedTags = tags;

        this.punchDetails = [];

        const self = this;

        if (!self.selectedTimeEnd || self.selectedTimeEnd == "") return;

        self.$http
          .post(`${self.$store.state.endpoint}attendances/byFilter`, {
            tags: self.selectedTags.tags,
            locations: self.selectedTags.locations,
            groupId: self.selectedTags.group,
            mode: self.selectedTags.mode,
            //include: "supervisorDetails",
            view: self.showUnapprovedPunches ? "" : "reports",
            showUnqiue: false,
            startDate: `${self.selectedTimeStart.format("YYYY-MM-DDT00:00:00")}.000Z`,
            endDate: `${self.selectedTimeEnd.format("YYYY-MM-DDT23:59:59")}.000Z`
          })
          .then(
            res => {
              console.log("response", res.body);

              var users = res.body.users;
              var response = res.body.attendances;
              var newUsers = {};

              self.punchDetails = [];

              //Reformatting the attendance day
              response = _.map(response, r => {
                r.attendanceDay = moment(r.attendanceDay).format("YYYY-MM-DD");
                return r;
              });

              //Create a blank template
              var dayTemplate = [];
              var day = self.selectedTimeStart.clone().set({
                hours: 0,
                minutes: 0,
                seconds: 0,
                milliseconds: 0
              });

              // console.log(
              //   "Checking if ",
              //   day.format(),
              //   " is between ",
              //   self.selectedTimeStart.format(),
              //   self.selectedTimeEnd.format()
              // );

              while (day.isBetween(self.selectedTimeStart, self.selectedTimeEnd, null, "[]")) {
                // console.log("Adding a day");

                dayTemplate.push(day.format("YYYY-MM-DD"));

                day.add(1, "day");
              }

              // console.log("Day template ", dayTemplate);

              var attendanceDayTemplate = {};
              _.each(dayTemplate, day => {
                attendanceDayTemplate[day] = { punches: [] };
              });
              attendanceDayTemplate = JSON.parse(JSON.stringify(attendanceDayTemplate));
              // console.log("tempalte", attendanceDayTemplate);

              for (var i = 0; i < users.length; i++) {
                newUsers[users[i]["email"]] = users[i];
                let attendances = JSON.parse(JSON.stringify(attendanceDayTemplate));

                for (var j in response) {
                  if (response[j].userId == users[i].id) {
                    if (response[j]["attendanceDay"] == undefined) {
                      continue;
                    }
                    if (attendances[response[j]["attendanceDay"]] == undefined)
                      attendances[response[j]["attendanceDay"]] = {};
                    if (attendances[response[j]["attendanceDay"]]["punches"] == undefined)
                      attendances[response[j]["attendanceDay"]]["punches"] = [];

                    attendances[response[j]["attendanceDay"]].punches.push(response[j]);
                  }
                }
                newUsers[users[i]["email"]].attendances = JSON.parse(JSON.stringify(attendances));
              }

              for (var i in newUsers) {
                let attendanceDays = newUsers[i].attendances;
                for (var each in attendanceDays) {
                  let attendances = attendanceDays[each].punches;

                  //Lets now calculate hours

                  var day = attendances;
                  day = _.sortBy(day, "time", "asc");

                  var actualHours = 0,
                    totalHours = 0;

                  //Calculating Actual
                  for (var d = 0; d < day.length; d++) {
                    //Start with the first punch
                    if (day[d].punchType == "IN") {
                      //Look for the next OUT
                      if (typeof day[d + 1] != "undefined") {
                        if (day[d + 1].punchType == "OUT") {
                          actualHours += moment(day[d + 1].time).diff(
                            moment(day[d].time),
                            "seconds"
                          );
                        }
                      }
                    }
                  }

                  if (actualHours != 0) actualHours = actualHours / 3600;

                  //TODO only find IN and Out pair
                  var firstPunch = false,
                    lastPunch = false;
                  if (day.length > 0) {
                    //Find first in

                    for (var d = 0; d < day.length; d++) {
                      if (day[d].punchType == "IN") {
                        firstPunch = day[d];

                        break;
                      }
                    }

                    for (var d = day.length - 1; d > 0; d--) {
                      if (day[d].punchType == "OUT") {
                        lastPunch = day[d];
                        break;
                      }
                    }

                    if (lastPunch) {
                      totalHours =
                        moment(lastPunch.time).diff(moment(firstPunch.time), "seconds") / 3600;
                    } else {
                      totalHours = 0;
                    }
                  }

                  if (firstPunch) {
                    newUsers[i].attendances[each].present = true;
                  } else {
                    newUsers[i].attendances[each].present = false;
                  }

                  if (totalHours < 0) totalHours = 0;
                  if (actualHours < 0) actualHours = 0;

                  newUsers[i].attendances[each].totalHours = totalHours;
                  newUsers[i].attendances[each].actualHours = actualHours;
                  newUsers[i].attendances[each].firstPunch = firstPunch;
                  newUsers[i].attendances[each].lastPunch = lastPunch;
                }
              }

              //self.allUsers = newUsers;
              resolve(newUsers);
            },
            error => {
              console.log(error);
              reject(error);
            }
          );
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.cusDivPadding {
  padding: 0 25px 0 25px;
}
</style>
